export const CANDIDATE_INFO_TABS = [
  { label: 'Основная информация', value: 'general' },
  { label: 'Профили', value: 'profiles' },
];

export const PROPOSED_VACANCIES_PREVIEW_COUNT = 3;
